export enum BehaviorCodeReactionsTableColumnsEnum {
  NAME = 'Name',
  POINTS = 'Points',
  TRIGGER_AT = 'Assigned At',
  PRINT_COPIES = 'Print Copies',
  ACTION_REPEAT = 'Action Repeat',
  ACTIONS = 'Actions'
}
